export interface UserData {
    userName: string;
    fullName: string;
    email: string;
    canEmulate: boolean;
    isEmulating: boolean;
    emulator: string | null;
    internal: boolean;
}

export function emptyUserData(): UserData {
    return {
        userName: '',
        fullName: '',
        email: '',
        canEmulate: false,
        isEmulating: false,
        emulator: null,
        internal: false,
    };
}
